import { EventPlace, trackEngagement } from "helpers/analytics";

const trackReplySuggestionEvent = (event: string, properties?: Record<string, unknown>): void => {
  trackEngagement(`Reply Suggestions: ${event}`, EventPlace.RichTextEditor, properties);
};

export const trackPreviewRepliesClicked = (): void => {
  trackReplySuggestionEvent("Preview replies clicked");
};

export const trackReportSuggestionsClicked = (): void => {
  trackReplySuggestionEvent("Report suggestions clicked");
};

export const trackGenerateReplyClicked = (promptIndex: number): void => {
  trackReplySuggestionEvent("Generate reply clicked", { promptIndex });
};

export const trackRegenerateReplyClicked = (): void => {
  trackReplySuggestionEvent("Regenerate reply clicked");
};

export const trackRating = (rating: string): void => {
  trackReplySuggestionEvent("Rating", { rating });
};

export const trackLearnMoreClicked = (): void => {
  trackReplySuggestionEvent("Learn more clicked");
};

export const trackLeaveFeedbackClicked = (): void => {
  trackReplySuggestionEvent("Leave feedback clicked");
};

export const trackRegenerateSuggestionsClicked = (): void => {
  trackReplySuggestionEvent("Regenerate suggestions clicked");
};
